import React from "react";

import Box from "@mui/material/Box";
import MuiSlider from "@mui/material/Slider";

import { getStep } from "../helper";
import { numberWithUnit } from "../../helper";

import InputNumeric from "../../Numeric/InputNumeric";

interface IInputNumericValueSlider {
  value: number;
  min: number;
  max: number;
  step?: number;
  prefix?: string;
  suffix?: string;
  unit?: string;
  hideEdges?: boolean;
  disabled?: boolean;
  disabledInput?: boolean;
  onChangeHandler: any;
}

const InputNumericValueSlider: React.FC<IInputNumericValueSlider> = ({
  value = 40,
  min = 0,
  max = 100,
  step,
  hideEdges = false,
  disabled = false,
  disabledInput = false,
  onChangeHandler = (e: any) => e,
  prefix,
  suffix,
  unit,
}) => {
  const [localValue, setLocalValue] = React.useState(String(value));

  React.useEffect(() => {
    setLocalValue(String(value));
  }, [value]);

  const handleBlur = (newValue?: number) => {
    let val = typeof newValue === "number" ? newValue : Number(localValue);
    if (val < min) val = min;
    else if (val > max) val = max;
    onChangeHandler(val);
  };

  if (min >= max) {
    return <span>{numberWithUnit({ value, unit })}</span>;
  }

  return (
    <>
      <Box
        sx={{
          typography: "body2",
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          gap: 1,
        }}
      >
        <InputNumeric
          value={localValue}
          unit={unit}
          prefix={prefix}
          suffix={suffix}
          disabled={disabledInput}
          submitHandler={(v: string) => {
            setLocalValue(v);
            handleBlur(v.length === 0 ? 0 : parseInt(v));
          }}
        />
      </Box>
      <MuiSlider
        data-testid="input-numeric-value-slider"
        marks
        min={min}
        max={max}
        value={parseInt(localValue)}
        step={step || getStep(max - min)}
        onChange={(e, newValue) => setLocalValue(String(newValue))}
        onChangeCommitted={(e, newValue) => onChangeHandler(newValue)}
        getAriaLabel={() => "Price range"}
      />
      {!hideEdges && (
        <Box
          sx={{
            typography: "body1",
            display: "flex",
            justifyContent: "space-between",
            mt: -2,
          }}
        >
          <span>{numberWithUnit({ value: min, unit })}</span>
          <span>{numberWithUnit({ value: max, unit })}</span>
        </Box>
      )}
    </>
  );
};
export default InputNumericValueSlider;
